module.exports = __webpack_public_path__ + "static/record.50dfb065.png";